exports.cs = {
  CSPS_DPS_BENEFITS: {
    DATE_OF_BIRTH: 'Datum narození:',
    LENGTH_OF_SAVINGS: 'Doba spoření v měsících:',
    AMOUNT_OF_SAVINGS: 'Naspořené peněžní prostředky:',
    LENGTH_OF_PAYMENTS: 'Požadovaná doba výplaty v měsících:',
    AGE_CONDITION: 'Podmínka věku',
    LENGTH_CONDITION: 'Podmínka doby spoření',
    AMOUNT_CONDITION: 'Podmínka minimální výše předdůchodu',
    CONDITION_RESULT_SUCCESS: 'Podmínky pro přiznání předdůchodu jsou splněny.',
    CONDITION_RESULT_FAIL: 'Podmínky pro přiznání předdůchodu nejsou splněny.',
    RESULT_AMOUNT: 'Hrubá výše předdůchodu činí:'
  },
  CZK: 'Kč',
  SUCCESS: 'Splněno',
  FAIL: 'Nesplněno'
}
